module.exports = __webpack_public_path__ + "assets/img/avatar.4787f788.png";